import idsTokensDefault from '../../utils/tokens/idsTokens';

const checkedRadioStyles = {
  enabled: (idsTokens = idsTokensDefault) => ({
    '&.Mui-checked svg': {
      stroke: idsTokens.radio.default.color.control.background.selected.enabled,
      fill: idsTokens.radio.default.color.control.icon.enabled,
    },

    '.MuiFormControlLabel-root.Mui-error &.Mui-checked svg': {
      stroke: idsTokens.radio.error.color.control.background.selected.enabled,
      fill: idsTokens.radio.error.color.control.icon.enabled,
    },
  }),

  hovered: (idsTokens = idsTokensDefault) => ({
    '.MuiFormControlLabel-root:hover &.Mui-checked svg': {
      stroke: idsTokens.radio.default.color.control.background.selected.hover,
      fill: idsTokens.radio.default.color.control.icon.hover,
    },

    '.MuiFormControlLabel-root.Mui-error:hover &.Mui-checked svg': {
      stroke: idsTokens.radio.error.color.control.background.selected.hover,
      fill: idsTokens.radio.error.color.control.icon.hover,
    },
  }),

  pressed: (idsTokens = idsTokensDefault) => ({
    '.MuiFormControlLabel-root:active &.Mui-checked svg': {
      stroke: idsTokens.radio.default.color.control.background.selected.pressed,
      fill: idsTokens.radio.default.color.control.icon.pressed,
    },

    '.MuiFormControlLabel-root.Mui-error:active &.Mui-checked svg': {
      stroke: idsTokens.radio.error.color.control.background.selected.pressed,
      fill: idsTokens.radio.error.color.control.icon.pressed,
    },
  }),

  disabled: (idsTokens = idsTokensDefault) => ({
    '.MuiFormControlLabel-root.Mui-disabled &.Mui-checked svg': {
      stroke: idsTokens.radio.default.color.control.background.selected.disabled,
      fill: idsTokens.radio.default.color.control.icon.disabled,
    },
  }),

  focused: (idsTokens = idsTokensDefault) => ({
    '.MuiFormControlLabel-root:focus &.Mui-checked svg': {
      stroke: idsTokens.radio.default.color.control.background.selected.enabled,
      fill: idsTokens.radio.default.color.control.icon.enabled,
    },

    '.MuiFormControlLabel-root.Mui-error:focus &.Mui-checked svg': {
      stroke: idsTokens.radio.error.color.control.background.selected.enabled,
      fill: idsTokens.radio.error.color.control.icon.enabled,
    },
  }),
};

const uncheckedRadioStyles = {
  enabled: (idsTokens = idsTokensDefault) => ({
    '& svg': {
      stroke: idsTokens.radio.default.color.control.border.enabled,
      fill: idsTokens.radio.default.color.control.background.unselected.enabled,
      marginLeft: -2,
      marginRight: -4,
    },

    '.MuiFormControlLabel-root.Mui-error & svg': {
      stroke: idsTokens.radio.error.color.control.border.enabled,
      fill: idsTokens.radio.error.color.control.background.unselected.enabled,
    },
  }),

  hovered: (idsTokens = idsTokensDefault) => ({
    '.MuiFormControlLabel-root:hover & svg': {
      stroke: idsTokens.radio.default.color.control.border.hover,
      fill: idsTokens.radio.default.color.control.background.unselected.hover,
    },

    '.MuiFormControlLabel-root.Mui-error:hover & svg': {
      stroke: idsTokens.radio.error.color.control.border.hover,
      fill: idsTokens.radio.error.color.control.background.unselected.hover,
    },
  }),

  pressed: (idsTokens = idsTokensDefault) => ({
    '.MuiFormControlLabel-root:active & svg': {
      stroke: idsTokens.radio.default.color.control.border.pressed,
      fill: idsTokens.radio.default.color.control.background.unselected.pressed,
    },

    '.MuiFormControlLabel-root.Mui-error:active & svg': {
      stroke: idsTokens.radio.error.color.control.border.pressed,
      fill: idsTokens.radio.error.color.control.background.unselected.pressed,
    },
  }),

  disabled: (idsTokens = idsTokensDefault) => ({
    '.MuiFormControlLabel-root.Mui-disabled & svg': {
      stroke: idsTokens.radio.default.color.control.border.disabled,
      fill: idsTokens.radio.default.color.control.background.unselected.disabled,
    },
    '.MuiFormControlLabel-root.Mui-disabled &.Mui-checked svg': {
      stroke: idsTokens.radio.default.color.control.background.selected.disabled,
      /**
       * This is styling the internal elements of the SVG because when they have the
       * same stroke value as the element with [data-layer=checked] it makes the
       * have a darker color outline, this is turn is because  the token
       * `defaultTokens.radio.color.control.border.disabled` has a
       * transparency value and having all three elements
       * overlap makes the color appear darker
       */
      '& [data-layer="background"], & [data-layer="stroke"]': {
        stroke: 'transparent',
      },
    },
  }),

  focused: (idsTokens = idsTokensDefault) => ({
    '.MuiFormControlLabel-root:focus & svg': {
      stroke: idsTokens.radio.default.color.control.border.enabled,
      fill: idsTokens.radio.default.color.control.background.unselected.enabled,
    },

    '.MuiFormControlLabel-root.Mui-error:focus & svg': {
      stroke: idsTokens.radio.error.color.control.border.enabled,
      fill: idsTokens.radio.error.color.control.background.unselected.enabled,
    },
  }),
};

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    width: idsTokens.radio.default.sizing.control.container.width,
    height: idsTokens.radio.default.sizing.control.container.height,
    padding: 0,
    top: 2,

    ...checkedRadioStyles.enabled(idsTokens),
    ...checkedRadioStyles.hovered(idsTokens),
    ...checkedRadioStyles.pressed(idsTokens),
    ...checkedRadioStyles.disabled(idsTokens),
    ...checkedRadioStyles.focused(idsTokens),

    ...uncheckedRadioStyles.enabled(idsTokens),
    ...uncheckedRadioStyles.hovered(idsTokens),
    ...uncheckedRadioStyles.pressed(idsTokens),
    ...uncheckedRadioStyles.disabled(idsTokens),
    ...uncheckedRadioStyles.focused(idsTokens),
  },
});
